// Models
import { UnitConfigViewModel } from "../models/unit-config-view.model";

export class ModbusHelper {
    /**
     * @param unitConfig: UnitConfigViewModel
     * @param remove: boolean // Flag to determine if to remove 300 or to add
     */
    static transformIds(unitConfig: UnitConfigViewModel, remove: boolean = false) {
        for (let i = 0; i < unitConfig.channels.length; i++) {
            if (unitConfig.channels[i].id !== '--') {
                if (remove) {
                    if (Number(unitConfig.channels[i].id) > 300000) {
                        unitConfig.channels[i].id = Number(unitConfig.channels[i].id) - 300000;
                    }
                } else {
                    if (Number(unitConfig.channels[i].id) < 300000) {
                        unitConfig.channels[i].id = Number(unitConfig.channels[i].id) + 300000;
                    }
                }
            }
        }

        return unitConfig;
    }
}
